import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Alert, Card, Col, Container, InputGroup, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PidFormControl from "./PidFormControl.jsx";
import rootStore from "../../../../stores/rootStore.js";

function OrderEntry() {
    const taxCertOrderStore = rootStore.taxCertOrderStore;

    const [orderState, setOrderState] = useState({
        taxAuthorities: [],
        clientReference: taxCertOrderStore.clientReference ?? '',
        taxAuthorityId: taxCertOrderStore.taxAuthorityId ?? '',
        searchTypes: [],
        searchType: taxCertOrderStore.searchType ?? '',
        searchTerm: taxCertOrderStore.searchTerm ?? '',
        selectedTaxAuth: taxCertOrderStore.taxAuthority
    });
    
    useEffect(() => {
        setOrderState(prevState => {return {
            ...prevState,
            taxAuthorities: taxCertOrderStore.taxAuthorities,
            clientReference: taxCertOrderStore.clientReference
        }});
    }, [taxCertOrderStore.clientReference, taxCertOrderStore.taxAuthorities]);

    useEffect(() =>{

    }, [orderState.taxAuthorityId])

    const handleTaxAuthChange = (event) => {
        let taxAuthId = null;
        if (event.target.value !== ''){
            taxAuthId = parseInt(event.target.value);
        }
        taxCertOrderStore.setSelectedTaxAuthorityId(taxAuthId);
        setOrderState(prevState => {return {...prevState, taxAuthorityId: event.target.value, selectedTaxAuth: taxCertOrderStore.taxAuthority, searchType: '', searchTerm: ''}});
    }

    const handleClientRefChange = (event) => {
        taxCertOrderStore.setClientReference(event.target.value);
        setOrderState(prevState => {return {...prevState, clientReference: event.target.value}});
    }

    const handleSearchTypeChange = (event) => {
        setOrderState(prevState => {return {...prevState, searchType: event.target.value, searchTerm: ''}});
        taxCertOrderStore.setSearchTerm(null);
        if (event.target.value == ''){
            taxCertOrderStore.setSearchType(null);
        } else {
            taxCertOrderStore.setSearchType(event.target.value);
        }
    }
    const handleSearchTermChange = (event) => {
        setOrderState(prevState => {return{...prevState, searchTerm: event.target.value}});
        if (event.target.value == ''){
            taxCertOrderStore.setSearchTerm(null)
        } else {
            taxCertOrderStore.setSearchTerm(event.target.value);
        }
    }

    const searchTermInvalid = !taxCertOrderStore.searchTermValid && orderState.searchTerm !== "";
    const selectedTaxAuthorityOffline = taxCertOrderStore.selectedTaxAuthorityOffline;
    const selectedTaxAuthorityOfflineReason = taxCertOrderStore.selectedTaxAuthorityOfflineReason;

    return (
        <Container className="order-card">
            <Card className="shadow-sm">
                <Card.Body>
                    <Row>
                        <Col xs={12}>
                            <h2 className="mb-2">Order Details</h2>
                            <p className="text-muted">Provide the search details for the property you need a tax certificate for.</p>
                        </Col>
                    </Row>
                    <Form>
                        <Row className="mt-3">
                            <Form.Group as={Col} md="12" controlId="clientReference">
                                <Form.Label>Client Reference</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        name="clientReference"
                                        value={orderState.clientReference}
                                        onChange={handleClientRefChange}
                                        placeholder="Optional reference for your records"
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Row>
                        <Row className="mt-3">
                            <Form.Group as={Col} md="12" controlId="taxAuthorityId">
                                <Form.Label>Tax Authority</Form.Label>
                                <Form.Select
                                    aria-label="Tax Authority"
                                    name={"taxAuthorityId"}
                                    value={orderState.taxAuthorityId}
                                    onChange={handleTaxAuthChange}
                                >
                                    <option value={""}>-- choose --</option>
                                    {orderState.taxAuthorities.map(ta => (
                                        <option key={ta.id} value={ta.id}>
                                            {ta.name}{ta.online === false ? " (Offline)" : ""}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                        {selectedTaxAuthorityOffline && (
                            <Row className="mt-3">
                                <Col xs={12}>
                                    <Alert variant="warning" className="mb-0">
                                        <strong>This municipality is currently unavailable.</strong> {selectedTaxAuthorityOfflineReason}
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                        {orderState.taxAuthorityId !== "" && (
                            <Row className="mt-3">
                                <Form.Group as={Col} md="12" controlId="searchType">
                                    <Form.Label>Search Method</Form.Label>
                                    <Form.Select
                                        aria-label="Search Type"
                                        name={"searchType"}
                                        value={orderState.searchType}
                                        onChange={handleSearchTypeChange}
                                        disabled={selectedTaxAuthorityOffline}
                                    >
                                        <option value={""}>-- choose --</option>
                                        {orderState.selectedTaxAuth?.supportsPidSearch && <option value={"pid"}>PID Search</option>}
                                        {orderState.selectedTaxAuth?.supportsRollSearch && <option value={"roll"}>Roll Search</option>}
                                        {orderState.selectedTaxAuth?.supportsMhrSearch && <option value={"mhr"}>MHR Search</option>}
                                        {orderState.selectedTaxAuth?.supportsAddressSearch && <option value={"address"}>Address Search</option>}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                        )}
                        {orderState.searchType === "pid" && (
                            <Row className="mt-3">
                                <Form.Group as={Col} md="12" controlId="searchTerm">
                                    <Form.Label>PID Number</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="searchTerm"
                                            value={orderState.searchTerm}
                                            onChange={handleSearchTermChange}
                                            as={PidFormControl}
                                            isInvalid={searchTermInvalid}
                                            placeholder="000-000-000"
                                            disabled={selectedTaxAuthorityOffline}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {taxCertOrderStore.searchTermErrorMsg || "Enter a valid PID."}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                    <Form.Text className="text-muted">Format: 000-000-000</Form.Text>
                                </Form.Group>
                            </Row>
                        )}
                        {orderState.searchType === "roll" && (
                            <Row className="mt-3">
                                <Form.Group as={Col} md="12" controlId="searchTerm">
                                    <Form.Label>Roll Number</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="searchTerm"
                                            value={orderState.searchTerm}
                                            onChange={handleSearchTermChange}
                                            isInvalid={searchTermInvalid}
                                            placeholder="Enter roll number"
                                            disabled={selectedTaxAuthorityOffline}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {taxCertOrderStore.searchTermErrorMsg || "Enter a valid roll number."}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Row>
                        )}
                        {orderState.searchType === "mhr" && (
                            <Row className="mt-3">
                                <Form.Group as={Col} md="12" controlId="searchTerm">
                                    <Form.Label>Mobile Home Reference</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="searchTerm"
                                            value={orderState.searchTerm}
                                            onChange={handleSearchTermChange}
                                            isInvalid={searchTermInvalid}
                                            placeholder="Enter reference number"
                                            disabled={selectedTaxAuthorityOffline}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {taxCertOrderStore.searchTermErrorMsg || "Enter a valid reference."}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Row>
                        )}
                        {orderState.searchType === "address" && (
                            <Row className="mt-3">
                                <Form.Group as={Col} md="12" controlId="searchTerm">
                                    <Form.Label>Property Address</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="searchTerm"
                                            value={orderState.searchTerm}
                                            onChange={handleSearchTermChange}
                                            isInvalid={searchTermInvalid}
                                            placeholder="Enter street address"
                                            disabled={selectedTaxAuthorityOffline}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {taxCertOrderStore.searchTermErrorMsg || "Enter a valid address."}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Row>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    )
}

export default observer(OrderEntry);
